
import { defineComponent, PropType, toRefs, computed } from 'vue';
import { ElRadioGroup, ElRadio } from 'element-plus';

export default defineComponent({
    components: {
        ElRadioGroup,
        ElRadio
    },
    props: {
        options: {
            type: Array as PropType<{
                label:string;
                value: string | number;
            }[]>,
            required: true
        },
        modelValue: {
            type: [Number, String] as PropType<string | number>,
            required: true
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        'update:modelValue' (val:number | string) {
            return true;
        }
    },
    setup (props, { emit }) {
        const {
            modelValue
        } = toRefs(props);

        const model = computed({
            get: () => modelValue.value,
            set: (val) => {
                emit('update:modelValue', val);
            }
        });

        return {
            model
        };
    }
});
